var React = require('react');

function ChevronThinDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron-thin-down"),React.createElement("path",{"d":"M17.418 6.109c0.272-0.268 0.709-0.268 0.979 0s0.271 0.701 0 0.969l-7.908 7.83c-0.27 0.268-0.707 0.268-0.979 0l-7.908-7.83c-0.27-0.268-0.27-0.701 0-0.969s0.709-0.268 0.979 0l7.419 7.141 7.418-7.141z","key":1})]);
}

ChevronThinDown.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = ChevronThinDown;

ChevronThinDown.default = ChevronThinDown;
